import apiClient from '../client';
import $U from '../urls';

export const getBasketOffers = () => {
  return apiClient.request('GET', $U.BASKET_OFFERS);
};

export const getDiscountItems = () => {
  return apiClient.request('GET', $U.DISCOUNT_ITEMS);
};

export const getExpiredOffers = () => {
  return apiClient.request('GET', $U.EXPIRED_BASKET_OFFERS);
};

export const getFutureOffers = () => {
  return apiClient.request('GET', $U.FUTURE_BASKET_OFFERS);
};
